import { render, staticRenderFns } from "./AppWarningModel.vue?vue&type=template&id=470728e7&scoped=true"
import script from "./AppWarningModel.vue?vue&type=script&lang=js"
export * from "./AppWarningModel.vue?vue&type=script&lang=js"
import style0 from "./AppWarningModel.vue?vue&type=style&index=0&id=470728e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470728e7",
  null
  
)

export default component.exports